import type { RouteRecordRaw } from 'vue-router'
import AocxRoutes from './aocx'
import CraeRoutes from './crae'
import CraeBrainRoutes from './crae-brain'
import CraeLlmRoutes from './crae-llm'
import CraenewRoutes from './craenew'
import RemoteCodexRoutes from './remote-codex'
import ServiceBridgeWecomRoutes from './service-bridge-wecom'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/control-center',
  component: Layout,
  name: 'ControlCenter',
  meta: {
    title: '中控台',
    icon: 'i-ant-design:appstore-outlined',
    auth: [],
    menuFlatten: true,
    breadcrumb: false,
  },
  children: [
    {
      path: 'api-document',
      name: 'ControlCenterApiDocumentIndex',
      component: () => import('@/views/control-center/api-document/index.vue'),
      meta: {
        title: '中控接口',
        icon: 'i-ant-design:api-outlined',
        auth: 'api-document:list',
      },
    },
    {
      path: 'application',
      name: 'ControlCenterApplicationIndex',
      component: () => import('@/views/control-center/application/index.vue'),
      meta: {
        title: '应用管理',
        icon: 'i-ant-design:appstore-add-outlined',
        auth: 'application:list',
      },
    },
    {
      path: 'finance-demo',
      name: 'ControlCenterFinanceDemo',
      component: () => import('@/views/control-center/finance-demo/organization.vue'),
      meta: {
        title: '财务演示站',
        icon: 'i-ant-design:account-book-outlined',
        auth: 'finance-demo',
      },
    },
    {
      path: 'finance-demo/organization',
      redirect: '/control-center/finance-demo',
      meta: {
        menu: false,
        auth: 'finance-demo',
      },
    },
    CraenewRoutes,
    CraeRoutes,
    AocxRoutes,
    CraeBrainRoutes,
    CraeLlmRoutes,
    RemoteCodexRoutes,
    ServiceBridgeWecomRoutes,
    {
      path: '/library/api-document',
      name: 'LibraryApiDocumentIndex',
      redirect: '/control-center/api-document',
      meta: {
        title: '中控接口',
        auth: 'api-document:list',
        menu: false,
        activeMenu: '/control-center/api-document',
      },
    },
  ],
}

export default routes
